import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Upload,
  message,
  Image,
  Alert,
} from "antd";
import { get_language, translate } from "../../../locale";
import SimpleReactValidator from "simple-react-validator";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import previewImage from "../../../assets/images/preview-image.png";
import { useNavigate, useParams } from "react-router-dom";
import Company from "../../../services/CompanyServices";
import UpdateTemplate from "../../../components/Modals/UpdateTemplate";

const FormSubscription = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { enterprise_id, type, data, setdata } = props;
  const { modules } = props;
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const [file, setFile] = useState(null);
  const [showTemplateUpdate, setShowTemplateUpdate] = useState(false);

  const [values, setValues] = useState({
    subscription_id: id,
    name: "",
    image: "",
    access_code: "",
    sensitive_data: true,
    modules: [],
    duration_days: 0,
  });
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    console.log("getBase64", img);
    reader.readAsDataURL(img);
  };

  const uploadProps = {
    accept: "image/png, image/jpeg, image/jpg",
    name: "image",
    showUploadList: false,
    /*
    headers: {
      authorization: "authorization-text",
    }, */
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
      }
      return false;
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        if (info.file) {
          uploadFile(info.file);
          // Get this url from response in real world.
          getBase64(info.file, (url) => {
            console.log("setUrl", url);
            setFile(url);
          });
        } else {
          uploadFile(null);
        }
        // console.log({ ...values, file: info.fileList[0].originFileObj });
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (url) => {
          setFile(url);
        });
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const uploadFile = async (file) => {
    try {
      const response =
        type === "add"
          ? await new Promise((resolve, reject) => {
              setValues((v) => ({ ...v, image: file }));
              resolve({ status: 201 });
            })
          : await Company.updateSubscription(
              { ...values, image: file },
              enterprise_id
            );
      if (response.status === 201) {
        message.success(
          translate("La {0} se cargó exitosamente.", translate("imagen"))
        );
      } else if (response.status >= 200 && response.status < 300) {
        message.success(
          translate("La {0} se guardó exitosamente.", translate("imagen"))
        );
      } else if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(response.statusText);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  const disabled = () => !simpleValidator.current.allValid();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    if (data && modules) {
      let tmp = [];
      for (let i = 0; i < modules.length; i++) {
        tmp.push(modules[i].module);
      }
      setValues((v) => ({
        ...v,
        name: data.name,
        image: data.image,
        access_code: data.access_code,
        modules: tmp,
        sensitive_data: data.sensitive_data,
        duration_days: data.duration_days,
      }));
      let url = data.image;
      if (url !== null && url !== undefined && url.indexOf("/media") === 0) {
        url = process.env.REACT_APP_API_URL + url;
      }
      setFile(url);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const onCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setValues((v) => ({ ...v, [name]: checked }));
  };

  const onFinish = () => {
    if (type === "edit") {
      updateSubscription();
    } else {
      createSubscription();
    }
  };

  const createSubscription = async () => {
    try {
      const response = await Company.createSubscription(values, enterprise_id);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate("La {0} se guardó exitosamente.", translate("suscripción"))
        );
        navigate("/admin/companies/" + enterprise_id);
      } else if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(response.statusText);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  const updateSubscription = async () => {
    const newValues = values;
    newValues.image = "";
    console.log("newValues", newValues);
    try {
      const response = await Company.updateSubscription(
        newValues,
        enterprise_id
      );
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate("La {0} se guardó exitosamente.", translate("suscripción"))
        );
      } else if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(response.statusText);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  const handleUpdateTemplate = (success) => {
    if (success) {
      message.success("La plantilla de invitación se actualizó exitosamente.");
    }
    setShowTemplateUpdate(false);
  };
  return (
    <Form onFinish={onFinish}>
      <Row gutter={16}>
        <Col span="12">
          <div className="flex flex-col">
            <div className="flex flex-row justify-center mb-4">
              <Image
                src={file ? file : previewImage}
                preview={file ? true : false}
                width={100}
                height={100}
              />
            </div>

            <div className="flex flex-row justify-center">
              <Upload {...uploadProps}>
                {(file == null || file == "") && (
                  <PrimaryButton className="px-10">
                    {translate("Subir logo")}
                  </PrimaryButton>
                )}
                {file && (
                  <PrimaryButton className="px-10">
                    {translate("Cambiar logo")}
                  </PrimaryButton>
                )}
              </Upload>
            </div>
          </div>
        </Col>
        <Col span="12">
          {error && (
            <Alert
              message={error}
              type="error"
              className="mb-6"
              closable
              onClose={() => setError("")}
            />
          )}
          <Row gutter={[16, 24]}>
            <Col span={12} className="gutter-row">
              <Checkbox
                name="sensitive_data"
                checked={values.sensitive_data}
                onChange={onCheckboxChange}
              >
                {translate("Datos sensibles")}
              </Checkbox>

              {/* <Checkbox
                name="active"
                checked={values.active}
                onChange={onCheckboxChange}
              >
                {translate("Activo")}
              </Checkbox> */}
            </Col>
            <Col span={12} className="gutter-row"></Col>

            <Col span={12} className="gutter-row">
              <Input
                placeholder={translate("Nombre")}
                name="name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
              />
              {simpleValidator.current.message(
                "name",
                values.name,
                "required|min:3",
                get_language === "es"
                  ? {
                      messages: {
                        required: "El campo Nombre es requerido",
                        min: "El campo Nombre debe tener al menos :min caracteres",
                      },
                    }
                  : {}
              )}
            </Col>
            {/* <Col span={12} className="gutter-row">
              <Input
                placeholder={translate("Meses de subscripción")}
                name="subscription_months"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.subscription_months || ""}
              />
              {simpleValidator.current.message(
                "subscription_months",
                values.subscription_months,
                "required|min:3",
                get_language === "es"
                  ? {
                      messages: {
                        required: "El campo Meses de subscripción es requerido",
                        min: "El campo Meses de subscripción debe tener al menos :min caracteres",
                      },
                    }
                  : {}
              )}
            </Col> */}
            {/* <Col span={12} className="gutter-row">
              <Input
                placeholder={translate("Reporte de nuevos usuarios")}
                name="new_users_reports"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.new_users_reports || ""}
              />
              {simpleValidator.current.message(
                "new_users_reports",
                values.new_users_reports,
                "required|min:3",
                get_language === "es"
                  ? {
                      messages: {
                        required:
                          "El campo Reporte de nuevos usuarios es requerido",
                        min: "El campo Reporte de nuevos usuarios debe tener al menos :min caracteres",
                      },
                    }
                  : {}
              )}
            </Col> */}

            {/* {type === "edit" && (
              <Col span={12} className="gutter-row">
                <Input
                  placeholder={translate("Código de subscripción")}
                  name="access_code"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.access_code || ""}
                />
                {simpleValidator.current.message(
                  "access_code",
                  values.access_code,
                  "required|min:3",
                  get_language === "es"
                    ? {
                        messages: {
                          required:
                            "El campo Código de subscripción es requerido",
                          min: "El campo Código de subscripción debe tener al menos :min caracteres",
                        },
                      }
                    : {}
                )}
              </Col>
            )} */}
            <Col span={24} className="gutter-row text-center">
              <PrimaryButton
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
              >
                {translate("Guardar")}
              </PrimaryButton>

              <PrimaryButton
                className="ml-4"
                onClick={() => setShowTemplateUpdate(true)}
              >
                Actualizar plantillas
              </PrimaryButton>
            </Col>
          </Row>
        </Col>

        <UpdateTemplate
          visible={showTemplateUpdate}
          onClose={(success) => handleUpdateTemplate(success)}
        />
      </Row>
    </Form>
  );
};

export default FormSubscription;
